export default __webpack_public_path__ + "static/media/nutritionfacts@3x.d5e0a9a2.jpg";